<template>
  <v-container fluid pa-0>
    <helpers-section-sub-header>
      Periodic Rebalancing:
      <p>Will rebalance existing holdings based on the entry rules you have configured</p>
    </helpers-section-sub-header>
    <v-row>
      <v-col cols="12" sm="6" md="2" xl="2">
        <v-checkbox
          v-model="criteria.rebalancing.enabled"
          hide-details
          density="compact"
          label="Enabled"
          class="shrink mr-2"
        />
      </v-col>
      <v-col v-if="1 == 2" cols="12" sm="6" md="4" xl="3">
        <v-checkbox
          v-model="criteria.rebalancing.f13_timing"
          hide-details
          density="compact"
          :disabled="!criteria.rebalancing.enabled"
          label="Rebalance when 13F data is updated quarterly"
          class="shrink mr-2"
        />
      </v-col>
      <v-col cols="12" sm="6" md="4" xl="3">
        <v-select
          v-model="criteria.rebalancing.frequency"
          :items="rebalancing_frequencies"
          :disabled="!criteria.rebalancing.enabled"
          item-title="text"
          label="Rebalancing Frequency"
          class="shrink"
          density="compact"
          variant="outlined"
          hide-details
        />
      </v-col>
    </v-row>
    <!-- Individual Position -->
    <helpers-section-sub-header>Individual Position:</helpers-section-sub-header>
    <v-row>
      <v-col cols="12" sm="6" lg="5" xl="4">
        <v-text-field
          v-model="criteria.max_individual"
          :label="'Max % of portfolio for an individual position'"
          suffix="%"
          density="compact"
          variant="outlined"
          hide-details
        />
      </v-col>

      <v-col cols="12" sm="6" lg="5" xl="4">
        <v-text-field
          v-model="criteria.max_individual_above_initial"
          :label="'Max % Above Initial Size Percentage'"
          suffix="%"
          density="compact"
          variant="outlined"
          hide-details
        />
      </v-col>

      <v-col cols="12">
        <v-radio-group v-model="criteria.trim_position_if_over_max">
          <v-radio
            :value="1"
            label="Reduce holdings in security to match max allowed if exceeded "
          />
          <v-radio
            :value="2"
            label="Do nothing to existing position but prevent any further accumulations"
          />
        </v-radio-group>
      </v-col>
    </v-row>

    <!-- Long vs Short Allocation -->
    <helpers-section-sub-header v-if="1 == 2">
      Long vs Short Allocation:
    </helpers-section-sub-header>
    <v-row v-if="1 == 2">
      <v-col cols="12" sm="6" md="4" xl="3">
        <v-text-field
          v-model="criteria.max_long"
          label="Max % Allocated to Longs"
          suffix="%"
          hide-details
          density="compact"
          variant="outlined"
          class="mt-0"
        />
      </v-col>
      <v-col cols="12" sm="6" md="4" xl="3">
        <v-text-field
          v-model="criteria.max_short"
          label="Max % Allocated to Shorts"
          suffix="%"
          density="compact"
          variant="outlined"
          hide-details
          class="mt-0"
        />
      </v-col>
    </v-row>

    <!-- Sector/Industry Allocations -->
    <helpers-section-sub-header class="mt-6">
      Sector/Industry Allocations:
    </helpers-section-sub-header>
    <v-row>
      <v-col cols="12" sm="6" md="4" xl="3">
        <v-text-field
          v-model="criteria.max_industry"
          label="Max % Allocated to individual industry"
          suffix="%"
          density="compact"
          variant="outlined"
          hide-details
          class="mt-0"
        />
      </v-col>
      <v-col cols="12" sm="6" md="4" xl="3">
        <v-text-field
          v-model="criteria.max_sector"
          label="Max % Allocated to individual sector"
          suffix="%"
          hide-details
          density="compact"
          variant="outlined"
          class="mt-0"
        />
      </v-col>
    </v-row>

    <!-- Marketcap Allocations -->
    <helpers-section-sub-header class="mt-6"> Marketcap Allocations: </helpers-section-sub-header>
    <v-row>
      <v-col cols="12" sm="6" md="4" xl="3">
        <v-text-field
          v-model="criteria.max_market_cap"
          label="Max % Allocated to any market cap segment"
          suffix="%"
          hide-details
          density="compact"
          variant="outlined"
          class="mt-0"
        />
      </v-col>
    </v-row>

    <!-- Limit Exposure for each Enabled Signal Source -->
    <helpers-section-sub-header class="mt-6 mb-4">
      Limit Exposure for each Enabled Signal Source:
    </helpers-section-sub-header>
    <v-row>
      <v-col cols="12" sm="4" xl="3">
        <div v-for="signal in criteria.signals" :key="signal.signal_type" class="mb-6">
          <h4>{{ signalLabel(signal.signal_id) }}</h4>
          <v-text-field
            v-model="signal.max_risk"
            placeholder="Max % of Portfolio"
            type="number"
            min="0"
            density="compact"
            variant="outlined"
            suffix="%"
            hide-details
          />
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// Modules

import { mapWritableState } from 'pinia'
import { useUserStore, useAppStore, useWwStore } from '@/store'
export default {
  data() {
    return {
      rebalancing_frequencies: [
        { text: 'Every 20 Trading Days', value: 1 },
        { text: 'Every 60 Trading Days', value: 2 },
        { text: 'Every 126 Trading Days', value: 3 },
        { text: 'Every 252 Trading Days', value: 4 }
      ]
    }
  },
  computed: {
    ...mapWritableState(useAppStore, ['whaleTraderCriteria']),
    /*...mapFields({
      appcriteria: 'app.whaleTraderCriteria',
     // criteria: 'app.whaleTraderCriteria.risk_management'
    }),*/
    criteria() {
      return this.whaleTraderCriteria.risk_management
    },
    appcriteria() {
      return this.whaleTraderCriteria
    }
  },
  methods: {
    signalLabel(id) {
      switch (id) {
        case 1:
          return '13F Signals'
        case 2:
          return '13D/G Signals'
        case 3:
          return 'Insider Signals'
        case 4:
          return 'Trend Signals'
        case 6:
          return 'WhaleIndex Signals'
        case 7:
          return 'Fundamental Signals'
      }
    }
  }
}
</script>
